<ng-container *ngIf="cs.vm$ | async as vm">
  <h2
    [dgxTestHook]="testHooks.GuestCheckoutTitle"
    class="checkout-guest__title"
  >
    {{ vm.cmsData.guestCheckoutTitle }}
  </h2>
  <p [dgxTestHook]="testHooks.GuestCheckoutDescription">
    {{ vm.cmsData.guestCheckoutDescription }}
  </p>
  <dgx-components-button-link
    [dgxGaClick]="{
      eventAction: 'checkout type',
      eventCategory: 'sign-in option',
      eventLabel: 'guest'
    }"
    [dgxTestHook]="testHooks.GuestCheckoutButton"
    [fill]="true"
    [routerPath]="checkoutRoutesPersonalDetails"
    class="py-5"
    variant="primary"
  >
    {{ vm.cmsData.guestCheckoutButtonLabel }}
  </dgx-components-button-link>
</ng-container>
